module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header', {
    staticClass: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "purchase-content"
  }, [_c('img', {
    attrs: {
      "src": _vm.currentLan === 'zh_CN' ? '../../static/images/purchase.png' : '../../static/images/purchase_en.png',
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cc9f5ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/purchase.vue
// module id = 574
// module chunks = 4 5 6